module.exports = __webpack_public_path__ + "static/media/IMG_7355-min.cec80b20.jpg";